import React, { useEffect, useState } from 'react';
import { Divider, styled } from '@mui/material';
import { StyledColumnBox, StyledRowBox } from '../../theme/StyledElements';
import { ClientCard } from '../SalesTableModal/ClientCard';
import { BasketCard } from '../SalesTableModal/BasketCard';
import { useMountedRef } from '../../hooks/useMountedRef';
import { BasketGroupData } from '../../models/BasketGroupData';
import { BasketDetails } from '../../models/BasketDetails';

export const StyledDivider = styled(Divider)(() => ({
    borderColor: '#134C03',
    borderLeftWidth: 'medium',
    margin: '0px',
    height: '20px',
    marginLeft: '40px',
    borderRightWidth: 'inherit'
}));

interface SharedClientDetailsProps {
    partagePanier: BasketGroupData[];
}

export function SharedClientDetails({
    partagePanier
}: SharedClientDetailsProps): React.ReactElement {
    const mounted = useMountedRef();
    const [sharedBasket, setSharedBasket] = useState<BasketGroupData[]>([]);

    useEffect(() => {
        if (partagePanier && mounted.current) {
            setSharedBasket(partagePanier);
        }
    }, [partagePanier]);

    const getBasketData = (basket: BasketDetails[]): JSX.Element[] => {
        return basket.map((item: BasketDetails, index: number): JSX.Element => {
            return <BasketCard item={item} key={index} isPrimaryClient={false} />;
        });
    };

    const getBasketImages = (): (JSX.Element | null)[] | null => {
        if (sharedBasket) {
            return sharedBasket.map((item: BasketGroupData, index: number) => {
                return (
                    <StyledRowBox key={index} sx={{ marginTop: '20px' }}>
                        <StyledColumnBox>
                            <StyledRowBox>
                                <ClientCard item={item} />
                            </StyledRowBox>
                            {getBasketData(item.idPanier ?? [])}
                        </StyledColumnBox>
                    </StyledRowBox>
                );
            });
        }
        return null;
    };

    return (
        <>
            <StyledColumnBox>{getBasketImages()}</StyledColumnBox>
        </>
    );
}
